import _ from 'underscore';
import { merge } from '@bingads-webui-universal/primitive-utilities';

import {
  RECOMMENDATION_PREFERENCES,
  RECOMMENDATION_PREFERENCES_ACCOUNT_LEVEL,
} from './consts';

export function getPreferences(preferencesService, isUserLevel = true) {
  const sessionData = isUserLevel ?
    preferencesService.findByNameAtUserLevel(RECOMMENDATION_PREFERENCES) :
    preferencesService.findByName(RECOMMENDATION_PREFERENCES_ACCOUNT_LEVEL);

  return _.result(sessionData, 'Data', {});
}

export function savePreferences(preferencesService, data, isUserLevel = true) {
  const Data = merge(
    {},
    getPreferences(preferencesService),
    data
  );
  const dataPackage = {
    Name: isUserLevel ? RECOMMENDATION_PREFERENCES : RECOMMENDATION_PREFERENCES_ACCOUNT_LEVEL,
    Data,
  };

  if (isUserLevel) {
    preferencesService.setAtUserLevel(dataPackage);
  } else {
    preferencesService.set(dataPackage);
  }
}
